import {BACKEND} from '../../consts/backend';

const Getbg = async () => {
  var requestOptions = {
    method: 'GET',
    redirect: 'follow',
  };

  const resp = await fetch(`${BACKEND}/bgs`, requestOptions);
  const sku = await resp.json();

  return sku;
};

export default Getbg;
